import { ResponseType } from 'parkway-web-common'
import { ITradeUnionMember, UnitEnum } from '../tradeUnionMembers/model'
import { ISchool } from '../school/model'
import { ISort } from 'app/common/interface'
export enum UnitType {
  DEPARTMENT = 'department',
  UNION_GROUP = 'union_group',
}

export enum PositionType {
  UNION_LEADER = 'union_leader',
  UNION_PRESIDENT = 'union_president',
  UNION_VICE_PRESIDENT = 'union_vice_president',
  UNION_MEMBER = 'union_member',
}

export interface IParamsGetUnit {
  search?: string
  limit?: number
  page?: number
  type?: UnitType
  schoolName?: UnitEnum
  schoolId?: number

  sorts?: ISort[]
}

export interface IPosition {
  id?: number
  name?: string
  description?: string
  is_deleted?: boolean
  type: PositionType
  member?: ITradeUnionMember
}

export interface IUnit {
  id?: number
  name?: string
  description?: string
  is_deleted?: boolean
  tradeUnionMembers?: ITradeUnionMember[]
  positions?: IPosition[]
  type: UnitType
  schoolName?: UnitEnum

  school?: ISchool
  code?: string
}

export type IResponseUnitList = ResponseType<{
  data: IUnit[]
  total: number
}>

export type IResponseUnitTotal = ResponseType<number>

export interface IPayloadCreateUnit {
  name?: string
  descriptions?: string
  type: UnitType

  unionLeaderId?: number | string
  unionPresidentId?: number | string
  unionVicePresidentIds?: (number | string)[]
  unionMemberIds?: (number | string)[]
  tradeUnionMemberIds?: number[]

  schoolName?: UnitEnum

  schoolId: number
  code?: string
}

export interface IPayloadUpdateUnit extends IPayloadCreateUnit {
  id?: number
}
